import { render, staticRenderFns } from "./why-choose.vue?vue&type=template&id=5e4ca225&scoped=true&"
import script from "./why-choose.vue?vue&type=script&lang=ts&"
export * from "./why-choose.vue?vue&type=script&lang=ts&"
import style0 from "./why-choose.vue?vue&type=style&index=0&id=5e4ca225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4ca225",
  null
  
)

export default component.exports